// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3oV_c","left":"StickyBox_left__2ca9s","right":"StickyBox_right__pK43v"};